import { render, staticRenderFns } from "./express-info.vue?vue&type=template&id=43f92b62&"
import script from "./express-info.vue?vue&type=script&lang=js&"
export * from "./express-info.vue?vue&type=script&lang=js&"
import style0 from "./express-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports